import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

export default function AuthLayout({ children }) {
  return (
    <Container>
      <Row>
        <Col>
          <Card className="login_card">
            <div className="login_form_head">
              <div className="login_brand_mark">EE</div>
              <div className="login_brand_title">Election Easy</div>
              <p className="lgHead_para">Sign in to manage your campaign</p>
            </div>
            <CardBody className="login_form_body">{children}</CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
